import React, { Component } from "react";
import "./reports-landing.styles.scss";

import { ReactComponent as UpcomingImage } from "../../assets/upcoming-auction.svg";
import { ReactComponent as OpenImage } from "../../assets/open-auction.svg";
import { ReactComponent as ArchiveImage } from "../../assets/archive.svg";
import { ReactComponent as IntermediateImage } from "../../assets/intermediate.svg";
import { ReactComponent as ApprovalImage } from "../../assets/approved.svg";
import { ReactComponent as RefundImage } from "../../assets/refund.svg";

import AuctionReport from "../auctionReports/auctionReports.page";
import VendorReport from "../vendorReports/vendorReports.page";
import UpcomingAuction from "../upcoming-auction/upcoming-auction.page";
import IntermediateScreen from "../intermediate-screen/intermediate-screen.page";
import ApprovalScreen from "../approval-screen/approval-screen.page";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Dispatch } from "react";

import {
  setPoScreen,
  setViewAuctionPage,
} from "../../redux/common/common.actions";
import {
  selectPOScreen,
  selectViewAuctionPage,
} from "../../redux/common/common.selectors";

import { Tabs } from "antd";
import BidReports from "../bidReports/bidReports.page";
import PoReports from "../poReports/poReports.page";
import PoDetails from "../poReports/poDetails";
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
  useLocation,
  Redirect,
} from "react-router-dom";

const { TabPane } = Tabs;

const ReportsLanding: React.FC = (props: any) => {
  const { setViewAuctionPage, selectedKey, poReportScreen, setPoScreens } =
    props;
  const { url, path } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();
  return (
    <div className="view-auction-landing">
      <Tabs
        // defaultActiveKey={sessionStorage.getItem("reportPage") || "60"}
        activeKey={location.pathname}
        onChange={(activeKey) => {
          setPoScreens();
          setViewAuctionPage(activeKey);
          sessionStorage.setItem("reportPage", activeKey);
          history.push(activeKey);
        }}
      >
        <TabPane tab={"Auction"} key={`${url}/auction`}></TabPane>
        <TabPane tab={"Vendor"} key={`${url}/vendor`}></TabPane>
        <TabPane tab={"Bids"} key={`${url}/bids`}></TabPane>
        <TabPane tab={"PO"} key={`${url}/po`}></TabPane>
      </Tabs>
      <Switch>
        <Route path={`${path}/auction`}>
          <AuctionReport />
        </Route>
        <Route path={`${path}/vendor`}>
          <VendorReport {...props} />
        </Route>
        <Route path={`${path}/bids`}>
          <BidReports {...props} />
        </Route>
        <Route path={`${path}/po`}>
          {poReportScreen ? <PoDetails {...props} /> : <PoReports {...props} />}
        </Route>
        <Redirect from={path} to={`${path}/auction`} />
      </Switch>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectedKey: selectViewAuctionPage,
  poReportScreen: selectPOScreen,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setViewAuctionPage: (activeKey: string) =>
      dispatch(setViewAuctionPage(activeKey)),
    setPoScreens: () => dispatch(setPoScreen(false)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportsLanding);
